<template>
	<div style="background-color: #c32a1a;">
		<div style="width: 1200px;margin: 0 auto;font-size: 25px;">
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
				background-color="#c32a1a" text-color="#fff" active-text-color="#fff" router
				style="height:52px !important;">
				<el-menu-item index="/" style="font-size:16px;margin-right:35px;">网站首页</el-menu-item>
				<el-menu-item index="/patent" style="font-size:16px;margin-right:35px;">
					<div class="patentNav">
						专利交易大厅
					</div>
				</el-menu-item>
				<el-menu-item index="/brand" style="font-size:16px;margin-right:35px;">
					<div class="brandNav">
						商标交易市场
					</div>
				</el-menu-item>
				<el-sub-menu style="margin-right: 35px;">
					<template #title>
						<div class="hoverText" @click.native="goLink('basicServices','_parent')"
						style="width: 100%; font-size:16px;">
							基础服务项目
						</div>
					</template>
					<el-menu-item>
						<div style="width: 100%; font-size:16px;"  @click.native="goServiceList(1)">
							专利业务
						</div>
					</el-menu-item>
					<el-menu-item>
						<div style="width: 100%; font-size:16px;"  @click.native="goServiceList(2)">
							商标服务
						</div>
					</el-menu-item>
					<el-menu-item>
						<div style="width: 100%; font-size:16px;"  @click.native="goServiceList(3)">
							版权业务
						</div>
					</el-menu-item>
					<el-menu-item style="margin-right: 30px;">
						<div style="width: 100%; font-size:16px;"  @click.native="goServiceList(4)">
							贯标业务
						</div>
					</el-menu-item>
					<el-menu-item style="margin-right: 30px;">
						<div style="width: 100%; font-size:16px;"  @click.native="goServiceList(5)">
							项目服务
						</div>
					</el-menu-item>
				</el-sub-menu>
				<el-menu-item style="margin-right: 35px;">
					<div @click.native="goLink('irpi','_blank')" style="font-size: 16px;">
						知识产权研究院
					</div>
				</el-menu-item>
				<el-menu-item index="/newsInformation" style="font-size:16px;margin-right: 35px;">行业新闻动态</el-menu-item>
				<el-menu-item index="/aboutUs" style="font-size:16px;">恒达品牌资讯</el-menu-item>
        <el-menu-item index="/zlQuery" style="font-size: 16px">专利期刊数据库</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	export default{
		setup() {
			// 导航菜单
			const activeIndex = ref('1')
			return {
				activeIndex
			}
		},
		methods: {
			goServiceList(index){
				let routeData = this.$router.resolve({
					path:'/serviceList',
					query:{
						index
					}
				})
				window.open(routeData.href, '_parent');
			},
			goLink(linkUrl,target){
				let routeData = this.$router.resolve({
					path:linkUrl
				})
				window.open(routeData.href, target);
			}
		},
	}
</script>

<style scoped>
	.el-icon svg{
		display: none !important;
	}
	.hoverText:hover{
		color: orange !important;
	}
	.brandNav::before,.patentNav::before {
	    display: block;
	    position: absolute;
		top:-28px;
		left:110px;
		width:45px;
		height: 45px;
	    content: '';
	    display: block;
	    position: absolute;
	    background: url(../../assets/img/home/hot_icon.png) no-repeat;
	    background-size: 100% 100%;
	    animation: move_forever 1s infinite linear;
	    -webkit-animation: move_forever 1s infinite linear;
	}
	@keyframes move_forever
	{
		from {top:-28px;}
		to {top:-26px;}
	}
	@-webkit-keyframes move_forever /*Safari and Chrome*/
	{
		from {top:-28px;}
		to {top:-26px;}
	}
</style>
